import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "./AuthContext";

export function TableList() {
  const [contacts, setContacts] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { authToken } = useAuth();

  useEffect(() => {
    const loadContacts = async () => {
      try {
        const token = localStorage.getItem("auth_token") || authToken;
        if (!token) {
          toast.error("No authentication token found");
          return;
        }
        
        console.log("Loading directory with token:", token ? "present" : "missing");
        const headers = { Authorization: `Bearer ${token}` };
        const res = await axios.get("/api/directory", { headers });
        console.log("Directory loaded successfully:", res.data.length, "contacts");
        setContacts(res.data);
      } catch (err) {
        console.error("Error loading directory:", err);
        if (err.response) {
          console.error("Response status:", err.response.status);
          console.error("Response data:", err.response.data);
          toast.error(`Error loading directory: ${err.response.data?.detail || err.response.status}`);
        } else {
          toast.error("Error loading directory - network error");
        }
      }
    };

    loadContacts();
  }, [authToken]);

  const toggleOpen = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const filteredContacts = contacts
    .filter((person) => {
      const query = searchQuery.toLowerCase();
      return (
        person.first_name.toLowerCase().includes(query) ||
        person.surname.toLowerCase().includes(query) ||
        (person.known_as && person.known_as.toLowerCase().includes(query))
      );
    })
    .sort((a, b) => a.surname.localeCompare(b.surname));

  return (
    <div className="accordion" id="contactAccordion">
      <div className="pb-2 border-bottom">
        <input
          type="text"
          className="form-control"
          placeholder="Search by name..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {filteredContacts.length === 0 ? (
        <p className="text-muted">No contacts found.</p>
      ) : (
        filteredContacts.map((person, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading-${index}`}>
              <button
                className={`accordion-button ${openIndex === index ? "" : "collapsed"}`}
                type="button"
                onClick={() => toggleOpen(index)}
                aria-expanded={openIndex === index}
                aria-controls={`collapse-${index}`}
              >
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <span>
                    <strong>{person.surname}</strong>, {person.first_name}
                    {person.known_as && ` (${person.known_as})`}
                  </span>

                  <span className="me-3">{person.status.charAt(0).toUpperCase() + person.status.slice(1)} {person.year_started}</span>
                </div>
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              className={`accordion-collapse collapse ${openIndex === index ? "show" : ""}`}
              aria-labelledby={`heading-${index}`}
            >
              <div className="accordion-body">
                <ul className="list-unstyled mb-0">
                  {person.title && <li><strong>Title:</strong> {person.title}</li>}
                  {person.cell_number && <li><strong>Cell:</strong> {person.cell_number} {person.preferred_number === "cell" && <span className="text-body-secondary">(Preferred)</span>}</li>}
                  {person.home_number && <li><strong>Home:</strong> {person.home_number} {person.preferred_number === "home" && <span className="text-body-secondary">(Preferred)</span>}</li>}
                  {person.email_address && <li><strong>Email:</strong> <a href={`mailto:${person.email_address}`}>{person.email_address}</a></li>}
                  {person.physical_address && <li><strong>Address:</strong> {person.physical_address}</li>}
                </ul>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
